export const SELECT_ACCOUNT_ADDRESS = "account.SELECT_ACCOUNT_ADDRESS";
export const SET_ADDRESS_TYPE = "account.SET_ADDRESS_TYPE";
export const SET_NEW_ADDRESS_ELEMENT = "account.SET_NEW_ADDRESS_ELEMENT";
